module.exports = __webpack_public_path__ + "static/media/standing-ohe.f650e463.png";